import { useState } from "react";
import { Timer, ChevronRight } from "lucide-react";

export const fmtSecs = (s) => (s >= 3600 ? `${Math.floor(s / 3600)}h ${Math.round((s % 3600) / 60)}m` : s >= 60 ? `${Math.round(s / 60)}m` : `${s}s`);
const SLOW = 600;
const ago = (iso) => Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));

const Step = ({ t, i, live }) => {
  const slow = t.secs >= SLOW;
  return (
    <li data-testid={`speed-step-${i}`} className={`flex items-center gap-3 px-3 py-1.5 text-xs border-t border-stone-100 ${slow ? "bg-red-50" : ""}`}>
      <span className="w-28 shrink-0 font-mono-ui text-stone-500">{new Date(t.at).toLocaleString("en-AU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
      <span className="font-semibold text-[#2B2A26] w-48 shrink-0">{t.phase}{live && <span className="ml-1 text-sky-700 font-normal">(now)</span>}</span>
      <span className="text-stone-500 truncate flex-1" title={t.detail}>{t.detail}</span>
      <span data-testid={`speed-step-secs-${i}`} className={`font-mono-ui shrink-0 ${slow ? "text-red-700 font-bold" : "text-stone-600"}`}>{fmtSecs(t.secs)}{slow ? " · slow" : ""}</span>
    </li>
  );
};

export const SpeedPanel = ({ kit }) => {
  const [open, setOpen] = useState(false);
  const steps = [...(kit.timings || [])];
  if (kit.step_open) steps.push({ ...kit.step_open, secs: ago(kit.step_open.at), live: true });
  if (!steps.length) return null;
  const total = steps.reduce((a, t) => a + t.secs, 0);
  const slow = steps.filter((t) => t.secs >= SLOW).length;
  return (
    <div data-testid="kit-speed-panel" className="border border-stone-200 bg-white mb-8">
      <button data-testid="kit-speed-toggle" onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-4 py-3 text-left text-sm hover:bg-stone-50 transition-colors">
        <ChevronRight size={15} className={`text-stone-500 transition-transform ${open ? "rotate-90" : ""}`} />
        <Timer size={15} className="text-stone-500" /><b className="text-[#2B2A26]">Build speed</b>
        <span data-testid="kit-speed-summary" className="text-stone-500">{steps.length} step(s) · {fmtSecs(total)} in total</span>
        {slow > 0 && <span className="ml-1 rounded-sm bg-red-100 px-2 py-0.5 text-[11px] font-semibold text-red-700">{slow} slow (over 10 min)</span>}
      </button>
      {open && <ul>{steps.slice().reverse().map((t, i) => <Step key={i} t={t} i={i} live={t.live} />)}</ul>}
    </div>
  );
};
